export default "__VITE_ASSET__CMD5O2Z7__"